const onlineBookingConfigFields = {
  allowed_durations: {
    name: 'allowed_durations',
    label: 'centers.online_booking_config.allowed_durations_label',
    veeValidation: true,
    rules: [],
    selectMultiple: true,
    help: 'centers.online_booking_config.allowed_durations_help',
    showHelp: true,
    helpMode: 'tooltip',
    options: [
      {
        text: 'global.durations.30min',
        value: 30,
      },
      {
        text: 'global.durations.60min',
        value: 60,
      },
      {
        text: 'global.durations.90min',
        value: 90,
      },
      {
        text: 'global.durations.120min',
        value: 120,
      },
      {
        text: 'global.durations.150min',
        value: 150,
      },
      {
        text: 'global.durations.180min',
        value: 180,
      },
      {
        text: 'global.durations.240min',
        value: 240,
      },
      {
        text: 'global.durations.300min',
        value: 300,
      },
      {
        text: 'global.durations.360min',
        value: 360,
      },
      {
        text: 'global.durations.420min',
        value: 420,
      },
      {
        text: 'global.durations.480min',
        value: 480,
      },
    ],
  },

  start_time: {
    name: 'start_time',
    label: 'centers.online_booking_config.start_time_label',
    veeValidation: true,
    rules: [],
    placeholder: '--:--,--:--,--:--,--:--,--:--,--:--,--:--',
    help: 'centers.online_booking_config.start_time_help',
    showHelp: true,
    helpMode: 'tooltip',
  },
  step_duration: {
    name: 'step_duration',
    label: 'centers.online_booking_config.step_duration_label',
    veeValidation: true,
    selectMultiple: false,
    rules: [],
    help: 'centers.online_booking_config.step_duration_help',
    showHelp: true,
    helpMode: 'tooltip',
    options: [
      // {
      //   text: 'global.durations.15m',
      //   value: 15,
      // },
      {
        text: 'global.step_durations.30min',
        value: 30,
      },
      {
        text: 'global.step_durations.45min',
        value: 45,
      },
      {
        text: 'global.step_durations.60min',
        value: 60,
      },
      {
        text: 'global.step_durations.90min',
        value: 90,
      },
      {
        text: 'global.step_durations.120min',
        value: 120,
      },
      {
        text: 'global.step_durations.150min',
        value: 150,
      },
      {
        text: 'global.step_durations.180min',
        value: 180,
      },
    ],
  },

  max_time_before_booking: {
    name: 'max_time_before_booking',
    label: 'centers.online_booking_config.max_time_before_booking_label',
    veeValidation: true,
    rules: [],
    help: 'centers.online_booking_config.max_time_before_booking_help',
    showHelp: true,
    helpMode: 'tooltip',
    prependText: 'global.durations.up_to',
    appendText: 'global.durations.days_in_advance',
    fieldAttributes: {
      type: 'number',
      step: 1,
    },
  },
  min_time_before_booking: {
    name: 'min_time_before_booking',
    label: 'centers.online_booking_config.min_time_before_booking_label',
    veeValidation: true,
    rules: [],
    help: 'centers.online_booking_config.min_time_before_booking_help',
    showHelp: true,
    helpMode: 'tooltip',
    prependText: 'global.durations.up_to',
    appendText: 'global.durations.minutes_before_start_booking',
    fieldAttributes: {
      type: 'number',
      step: 1,
    },
  },
  max_number_of_ongoing_upcoming_bookings_when_online_payment: {
    name: 'max_number_of_ongoing_upcoming_bookings_when_online_payment',
    label:
      'centers.online_booking_config.max_number_of_ongoing_upcoming_bookings_when_online_payment_label',
    veeValidation: true,
    rules: [],
    help:
      'centers.online_booking_config.max_number_of_ongoing_upcoming_bookings_when_online_payment_help',
    showHelp: true,
    helpMode: 'tooltip',
    // prependText: 'global.quantities.up_to',
    appendText: 'global.quantities.opened_bookings',
    fieldAttributes: {
      type: 'number',
      step: 1,
    },
  },
  max_number_of_ongoing_upcoming_bookings_when_subscription_payment: {
    name: 'max_number_of_ongoing_upcoming_bookings_when_subscription_payment',
    label:
      'centers.online_booking_config.max_number_of_ongoing_upcoming_bookings_when_subscription_payment_label',
    veeValidation: true,
    rules: [],
    help:
      'centers.online_booking_config.max_number_of_ongoing_upcoming_bookings_when_subscription_payment_help',
    showHelp: true,
    helpMode: 'tooltip',
    // prependText: 'global.quantities.up_to',
    appendText: 'global.quantities.opened_bookings',
    fieldAttributes: {
      type: 'number',
      step: 1,
    },
  },
  max_number_of_ongoing_bookings_per_week_when_online_payment: {
    name: 'max_number_of_ongoing_bookings_per_week_when_online_payment',
    label:
      'centers.online_booking_config.max_number_of_ongoing_bookings_per_week_when_online_payment_label',
    veeValidation: true,
    rules: [],
    help:
      'centers.online_booking_config.max_number_of_ongoing_bookings_per_week_when_online_payment_help',
    showHelp: true,
    helpMode: 'tooltip',
    // prependText: 'global.quantities.up_to',
    appendText: 'global.quantities.opened_bookings',
    fieldAttributes: {
      type: 'number',
      step: 1,
    },
  },
  max_number_of_ongoing_bookings_per_week_when_subscription_payment: {
    name: 'max_number_of_ongoing_bookings_per_week_when_subscription_payment',
    label:
      'centers.online_booking_config.max_number_of_ongoing_bookings_per_week_when_subscription_payment_label',
    veeValidation: true,
    rules: [],
    help:
      'centers.online_booking_config.max_number_of_ongoing_bookings_per_week_when_subscription_payment_help',
    showHelp: true,
    helpMode: 'tooltip',
    // prependText: 'global.quantities.up_to',
    appendText: 'global.quantities.opened_bookings',
    fieldAttributes: {
      type: 'number',
      step: 1,
    },
  },
  min_time_between_two_bookings: {
    name: 'min_time_between_two_bookings',
    label: 'centers.online_booking_config.min_time_between_two_bookings_label',
    veeValidation: true,
    rules: [],
    help: 'centers.online_booking_config.min_time_between_two_bookings_help',
    showHelp: true,
    helpMode: 'tooltip',
    appendText: 'global.durations.hours',
    fieldAttributes: {
      type: 'number',
      step: 1,
    },
  },
  allow_cancel_booking_event: {
    name: 'allow_cancel_booking_event',
    label: 'centers.online_booking_config.allow_cancel_booking_event_label',
    veeValidation: true,
    rules: [],
    help: 'centers.online_booking_config.allow_cancel_booking_event_help',
    showHelp: true,
    helpMode: 'tooltip',
  },
  min_time_before_cancellation: {
    name: 'min_time_before_cancellation',
    label: 'centers.online_booking_config.min_time_before_cancellation_label',
    veeValidation: true,
    rules: [],
    help: 'centers.online_booking_config.min_time_before_cancellation_help',
    showHelp: true,
    helpMode: 'tooltip',
    prependText: 'global.durations.up_to',
    appendText: 'global.durations.hours_before_start_booking',
    fieldAttributes: {
      type: 'number',
      step: 1,
      min: 0,
    },
  },
  min_time_before_player_slot_cancellation: {
    name: 'min_time_before_player_slot_cancellation',
    label: 'centers.online_booking_config.min_time_before_player_slot_cancellation',
    veeValidation: true,
    rules: [],
    help: 'centers.online_booking_config.min_time_before_player_slot_cancellation',
    showHelp: true,
    helpMode: 'tooltip',
    prependText: 'global.durations.up_to',
    appendText: 'global.durations.hours_before_start_booking',
    fieldAttributes: {
      type: 'number',
      step: 1,
      min: 0,
    },
  },
  reminder_hours_before_cancellation_deadline: {
    name: 'reminder_hours_before_cancellation_deadline',
    label: 'centers.online_booking_config.reminder_hours_before_cancellation_deadline',
    veeValidation: true,
    rules: [],
    help: 'centers.online_booking_config.reminder_hours_before_cancellation_deadline.help',
    showHelp: true,
    helpMode: 'tooltip',
    prependText: 'global.durations.up_to',
    appendText: 'global.durations.hours_before_start_booking',
    fieldAttributes: {
      type: 'number',
      step: 1,
      min: 0,
    },
  },
  membership_required: {
    name: 'membership_required',
    label: 'centers.online_booking_config.membership_required_label',
    veeValidation: true,
    rules: [],
    help: 'centers.online_booking_config.membership_required_help',
    showHelp: true,
    helpMode: 'tooltip',
  },
  memberships_allow_booking: {
    fieldPath: 'memberships_allow_booking',
    fieldReadPath: 'memberships_allow_booking',
    name: 'memberships_allow_booking',
    label: 'centers.online_booking_config.memberships_allow_booking_label',
    selectLabel: 'name',
    selectEntity: 'subscription-category',
    displayConfigName: 'search',
    selectConfigName: ['selector'],
    selectMultiple: true,
    selectValue: 'id',
    filters: [
      {
        filterField: 'type',
        modelField: null,
        value: 'membership',
      },
      {
        filterField: 'contentForSelector',
        modelField: null,
        value: true,
      },
    ],
    help: 'centers.online_booking_config.memberships_allow_booking_help',
    showHelp: true,
    helpMode: 'tooltip',
  },
  automatic_resource_selection: {
    name: 'automatic_resource_selection',
    label: 'centers.online_booking_config.automatic_resource_selection_label',
    veeValidation: true,
    rules: [],
    help: 'centers.online_booking_config.automatic_resource_selection_help',
    showHelp: true,
    helpMode: 'tooltip',
  },
  only_with_subscriptions: {
    name: 'only_with_subscriptions',
    label: 'centers.online_booking_config.only_with_subscriptions_label',
    veeValidation: true,
    selectMultiple: false,
    rules: [],
    help: 'centers.online_booking_config.only_with_subscriptions_help',
    showHelp: true,
    helpMode: 'tooltip',
    options: [
      // {
      //   text: 'global.durations.15m',
      //   value: 15,
      // },
      {
        text: 'global.only_with_subscriptions.subscription_only',
        value: 'subscription_only',
      },
      {
        text: 'global.only_with_subscriptions.payment_only',
        value: 'payment_only',
      },
      {
        text: 'global.only_with_subscriptions.both',
        value: 'both',
      },
    ],
  },
};

export const disciplineOnlineBookingConfigFields = {
  ...onlineBookingConfigFields,
};
export const resourceOnlineBookingConfigFields = {
  ...onlineBookingConfigFields,
};

export const subscriptionOnlineBookingConfigFields = {
  ...onlineBookingConfigFields,
};
